export default (tag) => ({
  info(msg, ...data) {
    console.log(`[${tag}]`, msg, ...data); // eslint-disable-line no-console
  },
  warn(msg, ...data) {
    console.warn(`[${tag}]`, msg, ...data); // eslint-disable-line no-console
  },
  error(msg, ...data) {
    console.error(`[${tag}]`, msg, ...data); // eslint-disable-line no-console
  }
});